import assetPath from '/app/xinglets/startpage-logged-out/language-switcher/src/assets/illustration-right.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')